import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
import { Textfit } from "react-textfit";
export default function STLBookingConfirmation() {
  const [data, setData] = useState();
  let { id } = useParams();
  const [quotation, setQuotation] = useState();
  const [transportation, setTransportation] = useState();
  const [transportationPlan, setTransportationPlan] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [commodityData, setCommodityData] = useState([]);

  const [groupData, setGroupData] = useState([]);
  const [linersData, setLinersData] = useState([]);
  const [containerData, setContainerData] = useState([]);
  const [terminalData, setTerminalData] = useState([]);
  const [depotsData, setDepotsData] = useState([]);

  const getMasterTerminal = async () => {
    const res = await api.get(`api/terminal/list`);
    const data = await res.data;
    setTerminalData(data);
  };
  const getDepots = async () => {
    try {
      const res = await api.get("api/depots/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setDepotsData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getMasterGroup = async () => {
    const res = await api.get(`api/master/group`);
    const data = await res.data;
    if (res.meta.status === true) {
      setGroupData(data.data);
    }
  };
  const getCommodity = async () => {
    try {
      const res = await api.get("api/commodity/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCommodityData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getQuotation = async (id) => {
    const res = await api(`api/quotation/data?QuotationId=${id}`);
    const data = await res.data;
    setQuotation(data);
  };
  const getData = async () => {
    const res = await api(`api/saleorder/detail/bookinginfo/${id}`);
    const data = await res.data;
    setData(data);
    getQuotation(data?.QuotationId);
  };
  const getTransportation = async () => {
    const res = await api(`api/saleorder/detail/transportation/${id}`);
    const data = await res.data;
    setTransportation(data);
    const array = []
    if (data?.InboundVoyNo) {
      array.push({
        VoyNo: data?.InboundVoyNo,
        From: data?.InboundGateOutId,
        To: data?.OutboundGateOutId,
        Mode: data?.InboundContainerGender,
        Type: data?.InboundTransportGroupId,
        ETD: data?.InboundETDGateOut,
        ETA: data?.InboundETAGateIn,
      });
    } else {
      array.push({});
    }
    if (data?.InboundVoyNo_2) {
      array.push({
        VoyNo: data?.InboundVoyNo_2,
        From: data?.InboundGateOutId,
        To: data?.OutboundGateOutId,
        Mode: data?.InboundContainerGender,
        Type: data?.InboundTransportGroupId,
        ETD: data?.InboundETDGateOut_2,
        ETA: data?.InboundETAGateIn_2,
      });
    } else {
      array.push({});
    }
    // if (data?.InboundVoyNo_3) {
    //   transportationPlan.push({
    //     VoyNo: data?.InboundVoyNo_3,
    //     From: data?.InboundGateOutId,
    //     To: data?.OutboundGateOutId,
    //     Mode: data?.InboundContainerGender,
    //     Type: data?.InboundTransportGroupId,
    //     ETD: data?.InboundETDGateOut_3,
    //     ETA: data?.InboundETAGateIn_3,
    //   });
    // } else {
    //   transportationPlan.push({});
    // }
    if (data?.OutboundVoyNo) {
      array.push({
        VoyNo: data?.OutboundVoyNo,
        From: data?.OutboundGateOutId,
        To: data?.InboundGateOutId,
        Mode: data?.OutboundContainerGender,
        Type: data?.OutboundTransportGroupId,
        ETD: data?.OutboundETDGateOut,
        ETA: data?.OutboundETAGateIn,
      });
    } else {
      array.push({});
    }
    if (data?.OutboundVoyNo_2) {
      array.push({
        VoyNo: data?.OutboundVoyNo_2,
        From: data?.OutboundGateOutId,
        To: data?.InboundGateOutId,
        Mode: data?.OutboundContainerGender,
        Type: data?.OutboundTransportGroupId,
        ETD: data?.OutboundETDGateOut_2,
        ETA: data?.OutboundETAGateIn_2,
      });
    } else {
      array.push({});
    }
    // if (data?.OutboundVoyNo_3) {
    //   transportationPlan.push({
    //     VoyNo: data?.OutboundVoyNo,
    //     From: data?.OutboundGateOutId,
    //     To: data?.InboundGateOutId,
    //     Mode: data?.OutboundContainerGender,
    //     Type: data?.OutboundTransportGroupId,
    //     ETD: data?.OutboundETDGateOut_2,
    //     ETA: data?.OutboundETAGateIn_2,
    //   });
    // } else {
    //   transportationPlan.push({});
    // }
    const nonEmptyObjects = array.filter((item) => Object.keys(item).length > 0);

    // กรองเอาเฉพาะ {}
    const emptyObjects = array.filter((item) => Object.keys(item).length === 0);

    // รวมลิสต์ที่ไม่ใช่ {} และ {} ไว้ท้ายสุด
    const result = [...nonEmptyObjects, ...emptyObjects];
    setTransportationPlan(result)
  };
  const getContaier = async () => {
    try {
      const res = await api.get("api/container/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setContainerData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocationData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getLiners = async () => {
    try {
      const res = await api.get("api/liners/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLinersData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
    getTransportation();
    getLocation();
    getCommodity();
    getMasterGroup();
    getLiners();
    getMasterTerminal();
    getDepots();
    getContaier();
  }, []);
  const pageCount = 1;
  // const pageCount = Math.ceil(data?.detail?.length / 6)
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(
      <>
        <page>
          <div class="header">
            <img
              src="/images/logo2.png"
              class="logo"
              style={{ width: "145px" }}
            />
            <div
              className="header_title"
              style={{
                width: "100%",
                marginRight: "40px",
                position: "relative",
              }}
            >
              <h4>SRITRANG LOGISTIC COMPANY LIMITED</h4>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h5>
              </div>
              <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span></span>
                  <span>C/O by: {quotation?.EmpFullName || ""}</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span></span>
                  <span>Contact No.: {quotation?.user?.EmpMobile || ""}</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span></span>
                  <span>E-Mail: {quotation?.user?.email || ""}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="content"
            style={{
              marginTop: "15px",
              marginBottom: "0px",
              display: "flex",
              justifyContent: "end",
              borderTop: "1px solid #000",
            }}
          >
            <h4>Booking Confirmation</h4>
          </div>
          <div
            class="content"
            style={{ marginTop: "0px", justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Customer:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.CustomerName || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Confirmed:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>
                {moment().format("DD/MM/YYYY")}
              </p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Contact Name:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                {quotation?.ContractName || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Quotation Ref No.:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>{quotation?.QuotationNo}</p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Contact No.:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {quotation?.Telephone || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Account Customer:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}> -</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Factory:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {data?.CustomerName}
                {/* updateFontSize(data?.Customer */}{" "}
                {quotation?.factory?.map((item) => item?.FactoryName)?.join() ||
                  "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Sale Order No.:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>{data?.SaleOrderNo}</p>
            </div>

            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%", marginTop: "10px" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Service Type:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {quotation?.ServiceType || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Service Routing:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {`${
                  locationData?.find(
                    (x) => x?.LocationId === transportation?.InboundGateOutId
                  )?.LocationName || "-"
                } - ${
                  locationData?.find(
                    (x) => x?.LocationId === transportation?.OutboundGateOutId
                  )?.LocationName || "-"
                } ${
                  transportation?.Delivery &&
                  `/ ${transportation?.Delivery} - ${
                    locationData?.find(
                      (x) => x?.LocationId === transportation?.InboundGateOutId
                    )?.LocationName
                  }`
                }` || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Gate Outbound:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {locationData?.find(
                  (x) => x?.LocationId === transportation?.OutboundGateOutId
                )?.LocationName || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Transit:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {"" || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Gate Inbound:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {locationData?.find(
                  (x) => x?.LocationId === transportation?.InboundGateOutId
                )?.LocationName || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%", marginTop: "10px" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Commodity:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {commodityData?.find(
                  (x) => x?.CommodityId === data?.CommodityId
                )?.CommodityName || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "45%" }}>
                Cargo Weight:{" "}
              </p>
              <p style={{ flexBasis: "45%" }}>
                {" "}
                {commodityData?.find(
                  (x) => x?.CommodityId === data?.CommodityId
                )?.CargoWeight || "-"}
              </p>
              <p style={{ flexBasis: "10%" }}> KGS</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%", marginTop: "10px" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Booking No.:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.BookingNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Liner:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {linersData?.find((x) => x?.LinersId === data?.LinersId)
                  ?.LinersName || "-"}
              </p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Volume:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                {containerData?.find(
                  (x) => x?.ContainerTypeId === data?.ContainerTypeId
                )?.ContainerTypeName || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                Size:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>
                {containerData?.find(
                  (x) => x?.ContainerTypeId === data?.ContainerTypeId
                )?.Size || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Port of Loading:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                {locationData?.find(
                  (x) => x?.LocationId === data?.POLLocationId
                )?.LocationName || "-"}
                ,{" "}
                {locationData?.find(
                  (x) => x?.LocationId === data?.PODLocationId
                )?.LocationName || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                ETD POL:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>
                {data?.ETDPOLDate
                  ? moment(data?.ETDPOLDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%", whiteSpace:'nowrap' }}>
                Port of Discharge:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                {locationData?.find(
                  (x) => x?.LocationId === data?.POLLocationId
                )?.LocationName || "-"}
                ,{" "}
                {locationData?.find(
                  (x) => x?.LocationId === data?.PODLocationId
                )?.LocationName || "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "50%" }}>
                ETA POD:{" "}
              </p>
              <p style={{ flexBasis: "50%" }}>
                {data?.ETAPODDate
                  ? moment(data?.ETAPODDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Feeder Vessel:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.FeederVessel || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Mother Vessel:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.MotherVessel || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "32.5%" }}
            >
              <p className="header_p" style={{ flexBasis: "44%" }}>
                Closing Date:{" "}
              </p>
              <p style={{ flexBasis: "56%" }}>
                {data?.ClosingDate
                  ? moment(data?.ClosingDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "32.5%" }}
            >
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Time:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.ClosingTime || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "20%" }}>
              <p className="header_p" style={{ flexBasis: "70%",whiteSpace:'nowrap' }}>
                SI Cut Off:{" "}
              </p>
              <p style={{ flexBasis: "30%" }}>
                {data?.CutOffSIDate
                  ? moment(data?.CutOffSIDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "15%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Time:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.CutOffSITime || "-"}</p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Free Time:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                Detention {data?.DET || "-"} Days at (POL)
              </p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "20%", whiteSpace:"nowrap" }}>
              <p className="header_p" style={{ flexBasis: "70%", whiteSpace:'nowrap' }}>
                VGM Cut Of:{" "}
              </p>
              <p style={{ flexBasis: "30%" }}>
                {data?.CutOffVGMDate
                  ? moment(data?.CutOffVGMDate).format("DD/MM/YYYY")
                  : "-"}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "15%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Time:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.CutOffVGMTime || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}></p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                Demurrage {data?.DEM || "-"} Days at (POL)
              </p>
            </div>

            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "20%" }}
            ></div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "15%" }}
            ></div>
          </div>

          <div style={{ textAlign: "center", fontSize: "18px" }}>
            Intended Transport Plan
          </div>
          <div className="containerR">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              style={{ width: "95%" }}
            >
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }}>From</th>
                <th style={{ border: "1px solid" }}>To</th>
                <th style={{ border: "1px solid" }}>Mode</th>
                <th style={{ border: "1px solid" }}>Vessel/Train/Truck</th>
                <th style={{ border: "1px solid" }}>Voy No.</th>
                <th style={{ border: "1px solid" }}>ETD</th>
                <th style={{ border: "1px solid" }}>Time</th>
                <th style={{ border: "1px solid" }}>ETA</th>
                <th style={{ border: "1px solid" }}>Time</th>
              </tr>
              {transportationPlan?.map((item) => {
                return (
                  <tr
                    style={{
                      border: "1px solid",
                      fontSize: "16px",
                      height: "27px",
                    }}
                  >
                    <td style={{ border: "1px solid" }}>
                      {locationData?.find((x) => x?.LocationId === item?.From)
                        ?.LocationName || "-"}
                    </td>
                    <td style={{ border: "1px solid" }}>
                      {locationData?.find((x) => x?.LocationId === item?.To)
                        ?.LocationName || "-"}
                    </td>
                    <td style={{ border: "1px solid" }}>{item?.Mode || '-'}</td>
                    <td style={{ border: "1px solid" }}>
                      {item?.Type
                        ? item?.Type == "G001"
                          ? "Truck"
                          : item?.Type == "G002"
                          ? "Train"
                          : "Vessel"
                        : "-"}
                    </td>
                    <td style={{ border: "1px solid" }}>{item?.VoyNo || '-'}</td>

                    <td style={{ border: "1px solid" }}>
                      {item?.ETD ? moment(item?.ETD).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td style={{ border: "1px solid" }}>{'-'}</td>
                    <td style={{ border: "1px solid" }}>
                      {item?.ETA ? moment(item?.ETA).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td style={{ border: "1px solid" }}>{'-'}</td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div style={{ textAlign: "center", fontSize: "18px" }}>
            Load Itinerary
          </div>

          <div className="containerR">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              style={{ width: "95%" }}
            >
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }}>Type</th>
                <th style={{ border: "1px solid" }}>Location</th>
                <th style={{ border: "1px solid" }}>Release Date</th>
                <th style={{ border: "1px solid" }}>From</th>
                <th style={{ border: "1px solid" }}>To</th>
                <th style={{ border: "1px solid" }}>Return Date</th>
                <th style={{ border: "1px solid" }}>Time</th>
                <th style={{ border: "1px solid" }}>Load Ref.</th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>{transportation?.InboundContainerGender || "Empty"} Container Depot</td>
                <td style={{ border: "1px solid" }}>
                  {depotsData?.find(
                    (x) => x?.DepotsId === transportation?.DepotsId
                  )?.DepotsName || "-"}
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.ActualPickupDate
                    ? moment(data?.ActualPickupDate).format("DD/MM/YYYY")
                    : data?.FirstPickupDate
                    ? moment(data?.FirstPickupDate).format("DD/MM/YYYY")
                    : "-"}
                </td>
                <td style={{ border: "1px solid" }}>{}</td>
                <td style={{ border: "1px solid" }} align="center">
                  {}
                </td>
                <td style={{ border: "1px solid" }}>{}</td>
                <td style={{ border: "1px solid" }}>{}</td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  Return Equip Delivery Terminal
                </td>
                <td style={{ border: "1px solid" }}>
                  {terminalData?.find(
                    (x) => x?.TerminalName === transportation?.TerminalName
                  )?.TerminalName || "-"}
                </td>
                <td style={{ border: "1px solid" }}>{}</td>
                <td style={{ border: "1px solid" }}>{}</td>
                <td style={{ border: "1px solid" }} align="center"></td>
                <td style={{ border: "1px solid" }}>
                  {" "}
                  {data?.ActualLadenDate
                    ? moment(data?.ActualLadenDate).format("DD/MM/YYYY")
                    : data?.FirstLadenDate
                    ? moment(data?.FirstLadenDate).format("DD/MM/YYYY")
                    : "-"}
                </td>
                <td style={{ border: "1px solid" }}>{}</td>
              </tr>
            </table>
          </div>
          <div style={{ padding: "6px 20px" }}>
            <div style={{ lineHeight: "1" }}>Remark : {quotation?.Remark}</div>
            <div style={{ lineHeight: "1" }}>
              ** Kindly check and ensure that the above contect is correct or
              call us immediately for any dispute otherwise we will assume it is
              in order.
            </div>
            <div style={{ lineHeight: "1" }}>
              ** Container Seal is subject to use carrier seal.
            </div>
            <div style={{ lineHeight: "1" }}>
              ** Nong Kai CY working hour 08.00 A.M. - 05.00 P.M. For any extra
              will be under OT surcharge.
            </div>
            <div style={{ lineHeight: "1" }}>
              ** Above rate are only apply for normal cargo only excluded the
              prohibited goods & Dangerous Goods.
            </div>
            <div style={{ lineHeight: "1" }}>
              ** Payment : Credit 7 days after received electronic invoice.
            </div>
            <div style={{ lineHeight: "1" }}>
              ** Cancellation must be inform 5 days before start working
              process.
            </div>
            <div>Note :-</div>
          </div>
        </page>
      </>
    );
  }
  return <>{rows}</>;
}
